import React from 'react';
import PlatformHeatmapList from '@/components/analytics/heatmapList';

const BestTimeToPostTab: React.FC = () => {
  return (
    <div>
      <PlatformHeatmapList />
    </div>
  );
};

export default BestTimeToPostTab;